import { t } from '@lingui/core/macro'
import { StepType, TourStep } from '@tecsinapse-org/portal-menu-kit'
import React from 'react'

export const homeTour = (
  title: string,
  callback: () => Promise<void>
): StepType[] => [
  {
    content: (
      <TourStep
        title={t`Bem vindo ao novo ${title}`}
        description={t`Sua interface foi reformulada para proporcionar uma navegação mais fácil e intuitiva.
          Explore as novidades e aproveite a melhoria na experiência.
          Esperamos que goste!`}
      />
    ),
    position: 'center',
    selector: 'body',
    actionAfter: async () => await callback()
  }
]
